var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chartNum"},[_c('div',{staticClass:"orderTitle"},[_vm._v("年租赁洗涤量(件)")]),_c('div',{staticClass:"box-item"},_vm._l((_vm.orderNum),function(item,index){return _c('li',{key:index,class:{
        'number-item': !isNaN(item),
        'mark-item': isNaN(item) && item != '楼',
        'unit': item == '楼',
        'firstIndex': index == 1
      }},[(!isNaN(item))?_c('span',[_c('div',{ref:"numberItem",refInFor:true,attrs:{"id":`numberItem${index}`}},_vm._l((10),function(child,Idx){return _c('span',{key:child},[_vm._v(_vm._s(Idx))])}),0)]):_c('span',{staticClass:"comma"},[_vm._v(_vm._s(item))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }